import { useCallback, useEffect, useMemo } from 'react';
import { useFetchWebsiteIndexEntriesQuery } from '../service';
import useUrlState from '../../../hooks/useUrlState';
import { useHistory } from 'react-router-dom';

export default function useGetCurrentWebsite() {
    const history = useHistory();

    const [urlState, setUrlState] = useUrlState();
    const { w_guid: websiteGuid } = urlState;

    const { data: websiteIndexEntries, isLoading: isLoadingWebsiteIndexEntries, isError } = useFetchWebsiteIndexEntriesQuery();

    const website = useMemo(() => websiteIndexEntries?.find((websiteIndexEntry) => websiteIndexEntry.guid === websiteGuid), [websiteGuid, websiteIndexEntries]);

    const setSelectedWebsite = useCallback(
        (websiteGuid: string) => {
            setUrlState({ w_guid: websiteGuid });
        },
        [setUrlState]
    );

    useEffect(() => {
        if (websiteIndexEntries) {
            if (websiteIndexEntries.length > 0) {
                const firstWebsite = websiteIndexEntries[0];

                if (!websiteGuid && firstWebsite) {
                    setUrlState({ w_guid: firstWebsite.guid });
                }
            } else {
                history.replace('/deep-analysis/setup-domain');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [websiteIndexEntries, websiteGuid]);

    return { website, setSelectedWebsite, isLoading: isLoadingWebsiteIndexEntries, isError };
}
